import { render } from "./group-of-case-card.vue?vue&type=template&id=9900f65a&scoped=true"
import script from "./group-of-case-card.vue?vue&type=script&lang=js"
export * from "./group-of-case-card.vue?vue&type=script&lang=js"

import "./group-of-case-card.vue?vue&type=style&index=0&id=9900f65a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9900f65a"]])

export default __exports__